export var GooglePayButtonColorEnumsObj = {
    DEFAULT: "default",
    BLACK: "black",
    WHITE: "white",
};
